import React from 'react'
import styled from 'styled-components'


const Logo = ({ imgSrc }) => {
  return (
    <Wrap id="logo-component">
      <a href="/">
        <img className="logo" src={imgSrc} alt="Logo" />
      </a>

    </Wrap>
  )
}

export default Logo

const Wrap = styled.div`

position: absolute;
left: 30px;
top: 30px;
z-index: 800;

 & img {
  width: 100px;

   @media (width > 800px) { 
    width: 180px;
      }
}
  `